/**
 * Anything that carries a person's names, in the camelCase profile shape (SC-270).
 */
export interface PersonNames {
  displayName?: string | null
  firstName?: string | null
  lastName?: string | null
  username?: string | null
}

/**
 * The name to show for a person, the only place this rule lives in the client (SC-438): their
 * display name when set, else first + last name, else username, else `fallback`.
 */
export function getDisplayName(person: PersonNames | null | undefined, fallback = 'User'): string {
  if (!person) return fallback

  const displayName = person.displayName?.trim()
  if (displayName) return displayName

  const fullName = [person.firstName?.trim(), person.lastName?.trim()].filter(Boolean).join(' ')
  if (fullName) return fullName

  return person.username?.trim() || fallback
}
